import { render, staticRenderFns } from "./arriveFill.vue?vue&type=template&id=5bb354b8&scoped=true"
import script from "./arriveFill.vue?vue&type=script&lang=js"
export * from "./arriveFill.vue?vue&type=script&lang=js"
import style0 from "./arriveFill.vue?vue&type=style&index=0&id=5bb354b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb354b8",
  null
  
)

export default component.exports